var React = require('react');

function EasyAddOns (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Easy-Add-Ons"),React.createElement("path",{"fill":"#12ebae","d":"M16 32c-8.837 0-16-7.163-16-16s7.163-16 16-16c8.837 0 16 7.163 16 16v0c0 8.837-7.163 16-16 16v0zM16 2.667c-7.364 0-13.333 5.97-13.333 13.333s5.97 13.333 13.333 13.333c7.364 0 13.333-5.97 13.333-13.333v0c0-7.364-5.97-13.333-13.333-13.333v0zM22.667 17.333h-13.333c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333v0h13.333c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333v0zM16 24c-0.736 0-1.333-0.597-1.333-1.333v0-13.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v0 13.333c0 0.736-0.597 1.333-1.333 1.333v0z","key":1})]);
}

EasyAddOns.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = EasyAddOns;

EasyAddOns.default = EasyAddOns;
